import {isParserError as e, parseMediaQueryList as r} from 'media-query-parser'
import {
	permToConditionPairs as t,
	hasRangeNumberKey as o,
	hasRangeRatioKey as n,
	attachPair as s,
	andRanges as i,
	DISCRETE_FEATURES as a,
	isDiscreteKey as l,
	isRangeRatioKey as m,
	hasRangeKey as u,
	hasDiscreteKey as f,
	notRatioRange as p,
	notNumberRange as d,
	boundRange as c
} from './helpers.js'
import {
	compileStaticUnitConversions as I,
	getRatio as N,
	getValue as T,
	simplifyMediaFeature as y
} from './units.js'
export const andPerms = (e, r) => {
	const t = []
	for (const o of e)
		for (const e of r) {
			const r = mergePerms(o, e)
			Object.keys(r).length > 0 && t.push(r)
		}
	return t
}
export const mergePerms = (e, r) => {
	const a = {}
	for (const r of t(e)) void 0 !== r[1] && s(a, r)
	for (const e of t(r))
		if (e[0] in a) {
			if (void 0 !== a[e[0]]) {
				const r = a
				if ('media-type' === e[0]);
				else if ('invalid-features' === e[0]) r[e[0]].push(...e[1])
				else if ('{false}' === r[e[0]] || '{false}' === e[1]) r[e[0]] = '{false}'
				else if ('{true}' === r[e[0]]) s(r, e)
				else if ('{true}' === e[1]);
				else {
					const r = a
					o(e) || n(e)
						? s(r, [e[0], i(r[e[0]], e[1])])
						: 'color-gamut' === e[0] || 'video-color-gamut' === e[0]
						? (r[e[0]] = [
								r[e[0]][0] && e[1][0],
								r[e[0]][1] && e[1][1],
								r[e[0]][2] && e[1][2],
								r[e[0]][3] && e[1][3]
						  ])
						: s(r, [e[0], r[e[0]] === e[1] ? r[e[0]] : '{false}'])
				}
			}
		} else s(a, e)
	return a
}
export const notPerms = e => e.map(e => invertPerm(e)).reduce((e, r) => andPerms(e, r))
export const invertPerm = e => {
	const r = t(e),
		o = []
	for (const e of r)
		if (void 0 !== e[1]) {
			let r, t
			if ('invalid-features' === e[0]) return [{[e[0]]: e[1]}]
			if ('media-type' === e[0]) continue
			if (((r = e), '{false}' === e[1])) t = [[e[0], '{true}']]
			else if ('{true}' === e[1]) t = [[e[0], '{false}']]
			else if (f(e))
				if ('color-gamut' === e[0]) {
					const r = e[1]
					t = [['color-gamut', [!r[0], !r[1], !r[2], !r[3]]]]
				} else
					t =
						'grid' === e[0]
							? [['grid', 0 === e[1] ? 1 : 0]]
							: Object.keys(a[e[0]])
									.filter(r => r !== e[1])
									.map(r => [e[0], r])
			else if (n(e)) {
				const r = p(e)
				t = ('{false}' === r ? ['{false}'] : r).map(r => [e[0], r])
			} else {
				const r = d(e)
				t = ('{false}' === r ? ['{false}'] : r).map(r => [e[0], r])
			}
			o.push([r, t])
		}
	const s = []
	for (const [, e] of o) for (const r of e) s.push({[r[0]]: r[1]})
	return s
}
export const mediaFeatureToPerms = (e, r) => {
	const t = y(e, r),
		o = [{'invalid-features': [e.feature]}]
	if ('invalid' === t.type) return o
	if ('boolean' === t.type)
		return 'color-gamut' === t.name
			? [{'color-gamut': [!1, !0, !0, !0]}]
			: 'grid' === t.name
			? [{grid: 1}]
			: l(t.name)
			? invertPerm({[t.name]: 'none'})
			: m(t.name)
			? [{[t.name]: [!1, [0, 1], [Number.POSITIVE_INFINITY, 1], !0]}]
			: [{[t.name]: [!1, 0, Number.POSITIVE_INFINITY, !0]}]
	if (l(t.name)) {
		if ('equals' === t.type) {
			const e = t.value
			if ('grid' === t.name) {
				if ('number' === e.type && (0 === e.value || 1 === e.value)) return [{grid: e.value}]
			} else if ('ident' === e.type && e.value in a[t.name]) {
				if ('color-gamut' !== t.name) return [{[t.name]: e.value}]
				{
					const r = ['srgb', 'p3', 'rec2020'].indexOf(e.value)
					if (-1 !== r) return [{'color-gamut': [!1, r <= 0, r <= 1, r <= 2]}]
				}
			}
		}
		return o
	}
	if (m(t.name)) {
		let e = null
		if ('equals' === t.type) {
			const r = N(t.value)
			null !== r && (e = [!0, r, r, !0])
		} else if ('single' === t.type) {
			const r = N(t.value)
			null !== r &&
				(e =
					'<' === t.op
						? [!0, [Number.NEGATIVE_INFINITY, 1], r, !1]
						: '<=' === t.op
						? [!0, [Number.NEGATIVE_INFINITY, 1], r, !0]
						: '>' === t.op
						? [!1, r, [Number.POSITIVE_INFINITY, 1], !0]
						: [!0, r, [Number.POSITIVE_INFINITY, 1], !0])
		} else if ('double' === t.type) {
			const r = N(t.min),
				o = N(t.max)
			null !== r && null !== o && (e = ['<=' === t.minOp, r, o, '<=' === t.maxOp])
		}
		return null === e ? o : [{[t.name]: c([t.name, e])}]
	}
	{
		let e = null
		if ('equals' === t.type) {
			const r = T(t.value, t.name)
			null !== r && (e = [!0, r, r, !0])
		} else if ('single' === t.type) {
			const r = T(t.value, t.name)
			null !== r &&
				(e =
					'<' === t.op
						? [!0, Number.NEGATIVE_INFINITY, r, !1]
						: '<=' === t.op
						? [!0, Number.NEGATIVE_INFINITY, r, !0]
						: '>' === t.op
						? [!1, r, Number.POSITIVE_INFINITY, !0]
						: [!0, r, Number.POSITIVE_INFINITY, !0])
		} else if ('double' === t.type) {
			const r = T(t.min, t.name),
				o = T(t.max, t.name)
			null !== r && null !== o && (e = ['<=' === t.minOp, r, o, '<=' === t.maxOp])
		}
		return null === e ? o : [{[t.name]: c([t.name, e])}]
	}
}
export const mediaConditionToPerms = (e, r) => {
	const t = []
	for (const o of e.children)
		'context' in o ? t.push(mediaFeatureToPerms(o, r)) : t.push(mediaConditionToPerms(o, r))
	return 'or' === e.operator || void 0 === e.operator
		? t.flat()
		: 'and' === e.operator
		? t.reduce((e, r) => andPerms(e, r))
		: notPerms(t[0])
}
export const simplifyPerms = e => {
	const r = [],
		o = new Set(),
		n = new Set()
	for (const i of e) {
		let e = !1
		if (Array.isArray(i['invalid-features']) && i['invalid-features'].length > 0) {
			for (const e of i['invalid-features']) o.add(e)
			e = !0
		}
		const a = {}
		for (const r of t(i))
			if ('invalid-features' !== r[0]) {
				if ('color-gamut' === r[0]) {
					const e = r[1].toString()
					'false,false,false,false' === e
						? (r[1] = '{false}')
						: 'true,true,true,true' === e && (r[1] = '{true}')
				} else u(r) && (r[1] = c(r))
				'{false}' === r[1]
					? (n.add(r[0]), (e = !0))
					: '{true}' === r[1] || ('media-type' === r[0] && 'all' === r[1]) || s(a, r)
			}
		e || r.push(a)
	}
	return {simplePerms: r, invalidFeatures: [...o].sort(), falseFeatures: [...n].sort()}
}
export const compileAST = (e, r = {}) => {
	const t = I(r),
		o = []
	for (const r of e.mediaQueries) {
		const e = []
		'not' === r.prefix
			? ('print' === r.mediaType
					? e.push({'media-type': 'not-print'})
					: 'screen' === r.mediaType && e.push({'media-type': 'not-screen'}),
			  void 0 !== r.mediaCondition &&
					e.push(...notPerms(mediaConditionToPerms(r.mediaCondition, t))))
			: void 0 === r.mediaCondition
			? e.push({'media-type': r.mediaType})
			: e.push(
					...mediaConditionToPerms(r.mediaCondition, t).map(e => ({
						...e,
						'media-type': r.mediaType
					}))
			  ),
			o.push(...e)
	}
	return simplifyPerms(o)
}
export const compileQuery = (t, o = {}) => {
	const n = r(t)
	if (e(n))
		throw new Error(`Error parsing media query list: ${n.errid} at chars ${n.start}:${n.end}`)
	return compileAST(n, o)
}
